import React, { useEffect, useRef, useState, version } from "react";
import copyIcon from "../../assets/copy.svg";
import exportIcon from "../../assets/export.svg";
import backlogIcon from "../../assets/backlog.svg";
import archiveIcon from "../../assets/archive.svg";
import "./SharePopup.css";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  deleteVersion,
  updateVersionArchiveStatus,
  updateVersionNote,
} from "../../store/projectsSlice";
import { useNavigate } from "react-router";
import { generateShareLink } from "../../store/usersSlice";
import toast from "react-hot-toast";

const ACCESS_OPTIONS = [
  { value: "VIEWER", label: "может просматривать" },
  { value: "COMMENTER", label: "может комментировать" },
  { value: "EDITOR", label: "может редактировать" },
];

const SharePopup = ({
  video,
  onClose,
  onOpenBacklog,
  updateVideo = () => {},
  className = "",
}) => {
  const [access, setAccess] = useState("COMMENTER");
  const popupRef = useRef();
  const [comment, setComment] = useState(video.releaseNotes || "");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [copied, setCopied] = useState(false);
  // const shareLink = `https://www.figma.com/design/${video?.id || ""}`;
  const [shareLink, setShareLink] = useState("");
  const [linkLoading, setLinkLoading] = useState(true);
  const [isSaved, setIsSaved] = useState(false);
  let updateCommentTimeout = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    dispatch(
      generateShareLink({
        resourceId: video.id,
        resourceType: "VIDEO",
        role: access,
      })
    ).then((res) => {
      if (!res.error) {
        setShareLink(res.payload);
      }
    });
  }, [access]);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  const archiveVersion = () => {
    if (confirm("Вы действительно хотите отправить версию в архив?")) {
      dispatch(
        updateVersionArchiveStatus({ versionId: video.id, isArchived: true })
      ).then((res) => {
        if (!res.error) {
          toast.success("Версия перемещена в архив");
          navigate(-1);
        }
      });
    }
  };

  const handleChangeComment = (value) => {
    setIsSaved(false);
    setComment(value);
    clearTimeout(updateCommentTimeout.current);
    updateCommentTimeout.current = setTimeout(() => {
      dispatch(
        updateVersionNote({ versionId: video.id, releaseNote: value })
      ).then((res) => {
        if (!res.error) {
          updateVideo();
          setIsSaved(true);
        }
      });
    }, 1000);
  };

  return (
    <div ref={popupRef} className={`share-popup-context-menu ${className}`}>
      <div className="share-popup-row share-popup-link-row">
        <span className="share-popup-label">Ссылка</span>
        <div className="share-popup-access-select">
          <select value={access} onChange={(e) => setAccess(e.target.value)}>
            {ACCESS_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="share-popup-row">
        <input
          className="share-popup-link-input"
          value={shareLink}
          readOnly
          placeholder="Загрузка..."
        />
        <button className="share-popup-copy-btn" onClick={handleCopy}>
          <img src={copyIcon} alt="copy" style={{ width: 18, height: 18 }} />
        </button>
        {copied && (
          <span className="share-popup-copied">{t("video.copied")}</span>
        )}
      </div>
      <textarea
        className="share-popup-comment"
        placeholder={
          video.version ? "Комментарий к видео" : "Комментарий к проекту"
        }
        value={comment}
        onChange={(e) => {
          handleChangeComment(e.target.value);
        }}
      />
      {isSaved && (
        <span className="share-popup-changes-saved">Изменения сохранены</span>
      )}
      <div className="share-popup-actions">
        <button
          className="share-popup-action"
          onClick={() => alert("Экспорт видео")}
        >
          <img src={exportIcon} alt="export" /> {t("video.exportVideo")}
        </button>
        {/* <button
          className="share-popup-action"
          onClick={() => {
            if (onClose) onClose();
            if (onOpenBacklog) onOpenBacklog();
          }}
        >
          <img src={backlogIcon} alt="backlog" /> {t("video.versionBacklog")}
        </button> */}
        <button className="share-popup-action" onClick={() => archiveVersion()}>
          <img src={archiveIcon} alt="archive" /> {t("video.sendToArchive")}
        </button>
      </div>
    </div>
  );
};

export default SharePopup;
